import ATipe611 from "./new/1lt (1).png";
import ATipe612 from "./new/1lt (2).png";
import ATipe613 from "./new/1lt (3).png";
import ATipe614 from "./new/1lt (4).png";
import ATipe615 from "./new/1lt (5).png";
import ATipe616 from "./new/1lt (6).png";
import ATipe617 from "./new/1lt (7).png";
import ATipe618 from "./new/1lt (8).png";
import ATipe619 from "./new/1lt (9).png";
import ATipe6110 from "./Tipe 6 (1 Lantai) 1.png";
import ATipe6111 from "./Tipe 6 (1 Lantai) 2.png";
import ATipe6112 from "./Tipe 6 (1 Lantai) 3.png";

import ATipe521 from "./new/tipe5 (1).png";
import ATipe522 from "./new/tipe5 (2).png";
import ATipe523 from "./new/tipe5 (3).png";
import ATipe524 from "./new/tipe5 (4).png";
import ATipe525 from "./new/tipe5 (5).png";
import ATipe526 from "./new/tipe5 (6).png";
import ATipe527 from "./Tipe5(2Lantai)1.png";
import ATipe528 from "./Tipe5(2Lantai)2.png";

import ATipe621 from "./new/tipe6 (1).png";
import ATipe622 from "./new/tipe6 (2).png";
import ATipe623 from "./new/tipe6 (3).png";
import ATipe624 from "./new/tipe6 (4).png";
import ATipe625 from "./new/tipe6 (5).png";
import ATipe626 from "./new/tipe6 (6).png";
import ATipe627 from "./new/tipe6 (7).png";
import ATipe628 from "./new/tipe6 (8).png";
import ATipe629 from "./Tipe 6B (2 Lantai) 1.png";
import ATipe6210 from "./Tipe 6B (2 Lantai) 2.png";

import ATipe721 from "./new/tipe7 (1).png";
import ATipe722 from "./new/tipe7 (2).png";
import ATipe723 from "./new/tipe7 (3).png";
import ATipe724 from "./new/tipe7 (4).png";
import ATipe725 from "./new/tipe7 (5).png";
import ATipe726 from "./new/tipe7 (6).png";
import ATipe727 from "./Tipe 7 (2 Lantai) 1.png";
import ATipe728 from "./Tipe 7 (2 Lantai) 2.png";
import ATipe729 from "./Tipe 7 (2 Lantai) 3.png";

import ATipe821 from "./new/tipe8 (1).png";
import ATipe822 from "./new/tipe8 (2).png";
import ATipe823 from "./new/tipe8 (3).png";
import ATipe824 from "./new/tipe8 (4).png";
import ATipe825 from "./new/tipe8 (5).png";
import ATipe826 from "./new/tipe8 (6).png";
import ATipe827 from "./new/tipe8 (7).png";
import ATipe828 from "./new/tipe8 (8).png";
import ATipe829 from "./new/tipe8 (9).png";
import ATipe8210 from "./new/tipe8 (10).png";
import ATipe8211 from "./Tipe 8 (2 Lantai) 1.png";
import ATipe8212 from "./Tipe 8 (2 Lantai) 2.png";
import ATipe8213 from "./Tipe 8 (2 Lantai) 3.png";

const AT61 = [
  ATipe611,
  ATipe612,
  ATipe613,
  ATipe614,
  ATipe615,
  ATipe616,
  ATipe617,
  ATipe618,
  ATipe619,
  ATipe6110,
  ATipe6111,
  ATipe6112,
];
const AT62 = [
  ATipe621,
  ATipe622,
  ATipe623,
  ATipe624,
  ATipe625,
  ATipe626,
  ATipe627,
  ATipe628,
  ATipe629,
  ATipe6210,
];
const AT52 = [
  ATipe521,
  ATipe522,
  ATipe523,
  ATipe524,
  ATipe525,
  ATipe526,
  ATipe527,
  ATipe528,
];
const AT72 = [
  ATipe721,
  ATipe722,
  ATipe723,
  ATipe724,
  ATipe725,
  ATipe726,
  ATipe727,
  ATipe728,
  ATipe729,
];
const AT82 = [
  ATipe821,
  ATipe822,
  ATipe823,
  ATipe824,
  ATipe825,
  ATipe826,
  ATipe827,
  ATipe828,
  ATipe829,
  ATipe8210,
  ATipe8211,
  ATipe8212,
  ATipe8213,
];

export { AT52, AT61, AT62, AT72, AT82 };
